import { Route, Routes } from "react-router-dom";
import FloatingBackButton from "../Components/FloatingBackButton";

import DLogin from "../Pages/Dashboard/Dashboard-Login/DLogin";
import Add_Admin from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/Add_Admin";
import AddDoctor from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/Add_Doctor";
import Add_Manager from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/Add_Manager";
import SuperAdmin from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/SuperAdmin";
import AdminActivities from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/AdminActivities";
import Discharge_and_Create_Slip from "../Pages/Dashboard/Main-Dashboard/AllPages/Doctor/Discharge_and_Create_Slip";
import Doctor_Profile from "../Pages/Dashboard/Main-Dashboard/AllPages/Doctor/Doctor_Profile";
import Book_Appointment from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/Book_Appointment";
import Manager_Profile from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/Manager_Profile";
import FrontPage from "../Pages/Dashboard/Main-Dashboard/GlobalFiles/FrontPage";
import RevenueDashboard from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/Revenue_Dashboard";
import AddAgent from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/Add_Agent";
import TestOrdersList from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/TestOrdersList";
import AdminDashboard from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/Admin_Dashboard";
import TestManagement from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/TestManagement";
// import RevenueManagement from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/RevenueManagement";
import ManagerRevenueDashboard from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/RevenueStatistics";
import Report from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/Report";
import AddReport from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/AddReport";
import ManageReports from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/ManageReports";
import PrintReport from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/PrintReport";
import CompletePartial from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/CompletePartial";
import TestCategoryManagement from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/TestCategoryManagemt";
import CommissionPercentage from "../Pages/Dashboard/Main-Dashboard/AllPages/Admin/CommissionPercentage";
import CommissionPage from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/CommissionPage";

import DailyCollection from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/DailyCollection";
import DailyCommission from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/DailyCommission";
import MonthlyCommission from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/MonthlyCommission";
import MonthlyCollection from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/MonthlyCollection";
import MonthlyCollectionShort from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/MonthlyCollectionShort";
import DailyCollectionShort from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/DailyCollectionShort";
import TestRelated from "../Pages/Dashboard/Main-Dashboard/AllPages/Manager/TestRelated";

import Page404 from "../Pages/Page404";

const AllRoutes = () => {
  return (
    <>
      <FloatingBackButton />
      <Routes>
        <Route path="/" element={<DLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/testorders" element={<TestOrdersList />} />
        <Route path="/dashboard" element={<FrontPage />} />
        <Route path="/adddoctor" element={<AddDoctor />} />
        <Route path="/report" element={<Report />} />
        <Route path="/report/manage" element={<ManageReports />} />
        <Route path="/report/add" element={<AddReport />} />
        <Route path="/report/complete" element={<CompletePartial />} />
        <Route path="/report/print" element={<PrintReport />} />
        <Route path="/addagent" element={<AddAgent />} />
        <Route path="/addManager" element={<Add_Manager />} />
        <Route path="/admin" element={<Add_Admin />} />
        <Route path="/admin-activities" element={<AdminActivities />} />
        <Route path="/doctorprofile" element={<Doctor_Profile />} />
        <Route path="/createslip" element={<Discharge_and_Create_Slip />} />
        <Route path="/bookappointment" element={<Book_Appointment />} />
        <Route path="/manager-profile" element={<Manager_Profile />} />
        <Route path="/revenue" element={<RevenueDashboard />} />
        <Route path="/statistics" element={<ManagerRevenueDashboard />} />

        <Route path="/commission" element={<CommissionPage />} />
        <Route path="/daily-commission" element={<DailyCommission />} />
        <Route path="/monthly-commission" element={<MonthlyCommission />} />
        <Route path="/daily-collection" element={<DailyCollection />} />
        <Route path="/daily-collection-short" element={<DailyCollectionShort />} />
        <Route path="/monthly-collection" element={<MonthlyCollection />} />
        <Route path="/monthly-collection-short" element={<MonthlyCollectionShort />} />

        {/* <Route path="/appointments" element={<Check_Appointment />} /> */}
        <Route path="/test-related" element={<TestRelated />} />
        <Route path="/test-management" element={<TestManagement />} />
        <Route path="/test-group-management" element={<TestCategoryManagement />} />
        <Route path="/commission-percentage" element={<CommissionPercentage />} />
        {/* <Route path="/revenue-management" element={<RevenueManagement />} /> */}
        {/* <Route path="/database-seeder" element={<DatabaseSeeder />} /> */}

        <Route path="/super-admin" element={<SuperAdmin />} />

        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  );
};

export default AllRoutes;